import { render, staticRenderFns } from "./FluxoCaixaMovimentacoesModule.vue?vue&type=template&id=dba537f6"
import script from "./FluxoCaixaMovimentacoesModule.vue?vue&type=script&lang=js"
export * from "./FluxoCaixaMovimentacoesModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports